import { LOGIN, LOGOUT, FORGOT_PASSWORD } from "../config";
import { post } from "./apiHelper";

export const login = (loginData) => post(LOGIN, loginData, { auth: false });

export const logout = () => post(LOGOUT);

export const forgotPassword = (loginData) => post(FORGOT_PASSWORD, loginData, { auth: false });
